import { NavLink } from 'react-router-dom';
import { navItems } from './Sidebar';

function BottomNav() {
  return (
    <nav
      className="d-md-none d-flex"
      style={{
        flexShrink: 0,
        backgroundColor: 'var(--color-sidebar-bg)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      {navItems.map((item) => (
        item.disabled ? (
          // Tela que ainda vai chegar: aparece esmaecida, não navega, e leva o
          // mesmo selo do sidebar — flutuando sobre o ícone, já que na largura
          // de um item da barra ele não cabe em linha.
          <span
            key={item.to}
            className="flex-fill d-flex flex-column align-items-center justify-content-center gap-1"
            aria-disabled="true"
            title="Disponível em breve"
            style={{ padding: '8px 4px 6px', fontSize: 10.5, fontWeight: 500, color: 'rgba(255, 255, 255, 0.35)', cursor: 'not-allowed' }}
          >
            <span className="nav-icon-wrap">
              <item.icon size={20} />
              {item.badge && (
                <span className="dev-badge dev-badge-floating">{item.badgeShort || item.badge}</span>
              )}
            </span>
            <span>{item.label}</span>
            <span className="visually-hidden"> (indisponível)</span>
          </span>
        ) : (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className="flex-fill d-flex flex-column align-items-center justify-content-center gap-1"
            style={({ isActive }) => ({
              padding: '8px 4px 6px',
              fontSize: 10.5,
              fontWeight: isActive ? 600 : 500,
              color: isActive ? '#fff' : 'rgba(255, 255, 255, 0.65)',
              transition: 'color 0.15s',
            })}
          >
            {({ isActive }) => (
              <>
                <item.icon size={20} style={{ color: isActive ? '#fff' : 'rgba(255, 255, 255, 0.65)' }} />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        )
      ))}
    </nav>
  );
}

export default BottomNav;
